import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';

const EligibilityNav = () => (
  <nav className="elig-nav">
    <div className="container nav-inner">
      <Link to="/" className="brand">
        <span className="brand-mark"><Icon name="heart" size={15} stroke={2.4}/></span>
        SupportCare
      </Link>
      <div className="nav-right">
        <span className="help-link">
        </span>
        <Link className="back-link" to="/">
          <Icon name="arrow-left" size={14} stroke={2.4}/> Back to home
        </Link>
      </div>
    </div>
  </nav>
);

export default EligibilityNav;
